import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Drawer, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import './css/HeaderSection.css';
import logo from '../../../assets/images/logo/2.png'; 

const menuItems = [
  { label: 'Sobre', path: '/sobre' },
  { label: 'Nossas Igrejas', path: '/igrejeiros' },
  { label: 'Secretaria', path: '/projetos' },
  { label: 'Tesouraria', path: '/faça-parte' },
  { label: 'Departamentos', path: '/eventos' },
  { label: 'Download Mídias', path: '/galeria' },
  { label: 'Diretoria', path: '/diretoria' },
];

export default function HeaderSection() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const go = (path) => {
    navigate(path);
    setDrawerOpen(false);
  };

  return (
    <header className="header-section">
      <div className="header-container">
        <Link to="/" className="logo">
          <img src={logo} alt="Logo" />
        </Link>

        {/* MENU DESKTOP */}
        {!isMobile && (
          <nav className="nav-links">
            {menuItems.map(item => (
              <a
                key={item.path}
                href={item.path}
                className={pathname === item.path ? 'active' : ''}
                onClick={e => {
                  e.preventDefault();
                  go(item.path);
                }}
              >
                {item.label}
              </a>
            ))}
          </nav>
        )}

        {/* ÍCONE HAMBURGUER MOBILE */}
        {isMobile && (
          <Button
            type="text"
            icon={<MenuOutlined />}
            className="mobile-menu-btn"
            onClick={() => setDrawerOpen(true)}
          />
        )}

        {/* DRAWER MOBILE */}
        <Drawer
          placement="right"
          closable={true}
          onClose={() => setDrawerOpen(false)}
          visible={drawerOpen}
          bodyStyle={{ padding: 0 }}
        >
          <div className="drawer-menu">
            {menuItems.map(item => (
              <a
                key={item.path}
                href={item.path}
                className={pathname === item.path ? 'active' : ''}
                onClick={e => {
                  e.preventDefault();
                  go(item.path);
                }}
              >
                {item.label}
              </a>
            ))}
          </div>
        </Drawer>
      </div>
    </header>
  );
}
